import { Breadcrumb, Checkbox, Col, Row, Spin, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { getRequest, postRequest, patchRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";

const CategoryItemSetting = () => {
  const { t } = useTranslation();
  // const user = authUserData()?.user_id;
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const { id } = useParams();

  const navigate = useNavigate();
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [categoryName, setCategoryName] = useState("");
  const [postChecked, setPostChecked] = useState(false);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [subcategoryCheckedValues, setSubcategoryCheckedValues] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);

  useEffect(() => {
    const getCategoryList = async () => {
      setLoading(true);

      try {
        // let apiResponse = await getRequest(
        //   `category-item-setting/${id}/get-material-by-checked/`
        // );
        let apiResponse = await getRequest(
          `company-material-code/1/get-pr-material-by-checked/`
        );


        if (apiResponse.data.success) {
          const hasNonNullCheckedId = apiResponse.data.data.some(
            (item) => item.is_checked.is_checked_id !== null
          );
          setPostChecked(hasNonNullCheckedId);

          if (!hasNonNullCheckedId) {
            // Set categoryList only if all is_checked_id values are null
            const postCategoryList1 = apiResponse.data.data;

            for (let i = 0; i < postCategoryList1.length; i++) {
              const item = postCategoryList1[i];
              item.is_checked = false;
            }

            // // Force the component to re-render
            setCategoryList([...postCategoryList1]);
            // setCategoryList(apiResponse.data.data);
            const subcategoryCheckedValues = {};

            apiResponse.data.data.forEach((item) => {
              const subCategory = item.sub_category;

              // Check if the subcategory is not already present in the state
              if (!subcategoryCheckedValues[subCategory]) {
                subcategoryCheckedValues[subCategory] = [];
              }

              if (item.is_checked === true) {
                subcategoryCheckedValues[subCategory].push(item.id.toString());
              }
            });

            setSubcategoryCheckedValues(subcategoryCheckedValues);

            const category = apiResponse.data.data.map(
              (item) => item.sub_category
            );
            const uniqueSubCategory = [...new Set(category)];
            setSubCategoryList(uniqueSubCategory);
          } else {
            try {
              // let apiResponse = await getRequest(
              //   "category-item-setting/selected-material/"
              // );
              let apiResponse = await getRequest(
                `category-item-setting/selected-material/?category_tree_id=${id}`
              );
              // let apiResponse = await getRequest(
              //   `company-material-code/1/get-pr-material-by-checked/`
              // );
              if (apiResponse.status) {
                setCategoryList(apiResponse.data.data);

                const subcategoryCheckedValues = {};

                apiResponse.data.data.forEach((item) => {
                  const subCategory = item.sub_category;

                  // Check if the subcategory is not already present in the state
                  if (!subcategoryCheckedValues[subCategory]) {
                    subcategoryCheckedValues[subCategory] = [];
                  }

                  if (item.is_checked === true) {
                    subcategoryCheckedValues[subCategory].push(
                      item.material_type.toString()
                    );
                  }
                });

                setSubcategoryCheckedValues(subcategoryCheckedValues);

                const category = apiResponse.data.data.map(
                  (item) => item.sub_category
                );
                const uniqueSubCategory = [...new Set(category)];
                setSubCategoryList(uniqueSubCategory);
              } else {
                ErrorNotificationMsg(t("error_in_subscription_list"));
              }
              setLoading(false);
            } catch (error) {
              setLoading(false);
            }
          }
        } else {
          ErrorNotificationMsg(t("error_in_subscription_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getCategoryList();
    getCategoryTree();
  }, [postChecked]);
  const getCategoryTree = async (data) => {
    try {
      const apiResponse = await getRequest(
        "category-tree/?no_pagination=True",
        data
      );
      if (apiResponse.data.success) {
        // Find the category with the matching id

        const matchingCategory = apiResponse.data.data.find(
          (category) => category.id === parseInt(id) //id is CategoryId
        );

        // Update the setCategoryName state with the matching category name
        if (matchingCategory) {
          setCategoryName(matchingCategory.name);
        } else {
          // Handle the case where no matching category is found
          //   console.error("No matching category found");
        }
      } else {
        // ErrorNotificationMsg(t("error_in_subscription_list"));
      }
    } catch (error) {
      // Handle error if the API call fails
      //   console.error("API call failed:", error);
    }
  };

  //   const onChange = (checkedValues) => {
  //     setCheckedValues(checkedValues); // Update the state when checkboxes are changed
  //   };

  const onChange = (subCategory, checkedValues) => {
    // Update the checked values for the specific subcategory
    setSubcategoryCheckedValues((prevValues) => ({
      ...prevValues,
      [subCategory]: checkedValues,
    }));

    // Update the existing categoryList array directly
    for (let i = 0; i < categoryList.length; i++) {
      const item = categoryList[i];

      if (item.sub_category === subCategory) {
        item.is_checked = checkedValues.includes(item.material_type.toString());
      }
    }

    // Force the component to re-render
    setCategoryList([...categoryList]);
  };

  const onChangePost = (subCategory, checkedValues) => {
    // Update the checked values for the specific subcategory
    setSubcategoryCheckedValues((prevValues) => ({
      ...prevValues,
      [subCategory]: checkedValues,
    }));

    // Update the existing categoryList array directly
    for (let i = 0; i < categoryList.length; i++) {
      const item = categoryList[i];

      if (item.sub_category === subCategory) {
        // item.is_checked =checkedValues.includes(item.id.toString())
        const itemChecked = checkedValues.includes(item.id.toString());
        // itemChecked ? item.is_checked : item.is_checked;
        if (itemChecked) {
          item.is_checked = true;
        } else {
          item.is_checked = false;
        }
        // if (checkedValues.includes(item.id.toString())) {
        //   return { ...item, is_checked: true };
        // } else {
        //   return { ...item, is_checked: false };
        // }
      }
    }

    // Force the component to re-render
    setCategoryList([...categoryList]);

    // Update the material_type property inside the state
    // setState((prevState) => ({
    //   ...prevState,
    //   material_type: checkedValues,
    // }));
  };

  const handleSubmit = async () => {
    const payload1 = {
      //   user_id: "14",
      select_material_type: categoryList.map((item) => ({
        category_tree: id,
        company: CompanyId,
        material_type: item.id,
        is_checked: item.is_checked,
      })),
    };

    const payload2 = {
      //   user_id: "14",

      select_material_type: categoryList.map((item) => ({
        id: item.id,
        category_tree: id,
        company: CompanyId,

        material_type: item.material_type,
        is_checked: item.is_checked,
      })),
    };

    try {
      setBtnLoading(true);
      let response;
      if (postChecked === false) {
        response = await postRequest("category-item-setting/", payload1);
      } else {
        response = await patchRequest(
          `category-item-setting/${CompanyId}/`,
          payload2
        );
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          postChecked === false
            ? t("category_setting_added_successfully")
            : t("category_setting_updated_successfully")
        );
        setPostChecked((checked) => (checked = true));
        //   setState(initialState);
        //   formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        // navigate("/employee");
      }
    } catch (error) {
      //   ErrorNotificationMsg(
      //     EmployeeId === null
      //       ? t("error_in_adding_employee")
      //       : t("error_in_updating_employee")
      //   );
      setBtnLoading(false);
    }
  };

  const capitalize = (str) => {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Manage and configure category-specific settings and details.
                </span>
              }
            >
              <h3> Category Item Setting </h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Category Item Setting</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>
      <Spin spinning={loading}>
        <section className="grid-sec  mt-5">
          <div className="PR-body">
            <Row className="tblheader">
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={24}
                xl={24}
                className="tbl-heading"
              >
                <h1>{`Item - ${categoryName}`}</h1>
              </Col>
            </Row>
            {/* subCategoryList&& */}
            {subCategoryList &&
              subCategoryList.map((subcategory) => (
                <React.Fragment key={subcategory}>
                  <Row className="tblheader">
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={24}
                      xl={24}
                      className="tbl-heading"
                    >
                      <h1>{`${capitalize(subcategory)}`}</h1>
                    </Col>
                  </Row>
                  <div className="itemcheckwrp">
                    <Checkbox.Group
                      style={{
                        width: "100%",
                      }}
                      onChange={
                        postChecked
                          ? (checkedValues) =>
                              onChange(subcategory, checkedValues)
                          : (checkedValues) =>
                              onChangePost(subcategory, checkedValues)
                      }
                      value={subcategoryCheckedValues[subcategory] || []} // Set the checked values from the state
                    >
                      <Row gutter={32}>
                        {categoryList &&
                          categoryList
                            .filter(
                              (item) => item?.sub_category === subcategory
                            )
                            .map((item) => (
                              <Col key={item.id} xs={24} sm={12} md={8}>
                                <Checkbox
                                  value={
                                    postChecked
                                      ? item?.material_type?.toString()
                                      : item?.id?.toString()
                                  }
                                >
                                  {item.type_name}
                                </Checkbox>
                              </Col>
                            ))}
                      </Row>
                    </Checkbox.Group>
                  </div>
                </React.Fragment>
              ))}

            <div className="btnwrp">
              <ButtonField
                className="CancelGradiantBtn"
                type="primary"
                htmlType="Cancel"
                label="Cancel"
                onClick={() => navigate("/category-item-setting")}
              />
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                loading={btnLoading}
                onClick={handleSubmit}
                label="Save"
              />
            </div>
          </div>
        </section>
      </Spin>
    </>
  );
};

export default CategoryItemSetting;
